// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-2e03b3a0] .login-field .v-messages__message{color:#2a4f66!important;font-weight:700!important;line-height:1.5em}[data-v-2e03b3a0] .login-field .v-messages.theme--light.error--text .v-messages__wrapper .v-messages__message{color:#f44336!important;font-weight:700!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
